import { render, staticRenderFns } from "./Footer_phone.vue?vue&type=template&id=634cb06f&scoped=true&"
import script from "./Footer_phone.vue?vue&type=script&lang=js&"
export * from "./Footer_phone.vue?vue&type=script&lang=js&"
import style0 from "./Footer_phone.vue?vue&type=style&index=0&id=634cb06f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634cb06f",
  null
  
)

export default component.exports